import './assets/main.css'

import { createApp,provide } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// 额外引入图标库
import ArcoVue from '@arco-design/web-vue';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';

import i18n from "./lang/index"

import { Message } from '@arco-design/web-vue';
import '@arco-design/web-vue/es/message/style/index.css'

   
import {useLang,useAvatar} from '@/stores/index'

import { t } from '@/lang/index'
//多语言数据

//const translate = t()
const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)
app.use(ArcoVue);
app.use(ArcoVueIcon);
app.provide('Message', Message);
app.provide('config', config);
app.provide('translate', t);
useAvatar(app)
useLang(app)
app.mount('#app')
